export const PilgrimUrl = {
  // Report
  // get all pre-reserve by status
  SearchPilgrim: '/pilgrim/PilgrimQuery/SearchPilgrims',
}
